import { isLive } from "utils/environment";

/**
 * User-facing terminology for event-backed presentation surfaces.
 * API names, route paths, and internal event models remain unchanged.
 */
export const getEventTerminology = () => {
  const singular = isLive() ? "presentation" : "event";
  const plural = isLive() ? "presentations" : "events";

  return {
    singular,
    plural,
    Singular: `${singular.charAt(0).toUpperCase()}${singular.slice(1)}`,
    Plural: `${plural.charAt(0).toUpperCase()}${plural.slice(1)}`,
  };
};
